import { NextPage, NextPageContext } from "next";
import BusinessSolution from "@containers/BusinessSolution";
import { getCategoryDetail } from "@libraries/api/category-business/category.repositories";
import { IbusinessCategory } from "@containers/BusinessSolution/interface";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { localeKey } from "@constants/locale-key";

const PageBusinessSolution: NextPage = ({ data, dataNavbar }: any) => {
  return (
    <BusinessSolution children={data as IbusinessCategory} dataNavbar={dataNavbar} />
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const language = `${context.locale}`;
  const slug = `${context.query.category}`;

  context.res?.setHeader(
    "Cache-Control",
    "public, max-age=7884000, immutable"
  );

  const responseBusinessSolutionDetail = await getCategoryDetail(slug, language);
  const responseProductMenu = await getProductMenu({ level: 0 }, language);

  if (!responseBusinessSolutionDetail) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false,
      },
    };
  }

  const { data } = JSON.parse(JSON.stringify(responseBusinessSolutionDetail));
  const { data: dataProductMenu } = JSON.parse(JSON.stringify(responseProductMenu));

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: data?.metaTitle || "",
      description: data?.metaDescription || "",
      canonical: data?.canonical || "",
      data,
      dataNavbar: dataProductMenu,
    },
  };
}

export default PageBusinessSolution;
